import { Mail, Phone, MapPin, CalendarClock } from "lucide-react";
import PageHeader from "@/components/PageHeader";
import ContactForm from "@/components/ContactForm";
import { COMPANY } from "@/data/content";

const INFO = [
  { icon: Phone, label: "Call us", value: COMPANY.phone, href: COMPANY.phoneHref },
  { icon: Mail, label: "Email", value: COMPANY.email, href: COMPANY.emailHref },
  { icon: MapPin, label: "HQ", value: COMPANY.address },
  { icon: CalendarClock, label: "Hours", value: "Mon–Fri · 9:00–17:00 ET" },
];

export default function ContactPage() {
  return (
    <>
      <PageHeader
        eyebrow="/ Contact"
        title={<>Book a free <span className="text-gradient">consultation.</span></>}
        copy="Tell us where your platform hurts. Pick a date and time that works — a senior engineer will confirm within one business day."
      />

      <section className="relative pb-10">
        <div className="mx-auto max-w-7xl px-6 md:px-10 grid lg:grid-cols-12 gap-8 items-start">
          <div className="lg:col-span-4 space-y-4">
            {INFO.map((item) => (
              <div key={item.label} className="glass rounded-2xl p-5 flex items-center gap-4" data-testid={`contact-info-${item.label.toLowerCase().replace(/\s+/g, "-")}`}>
                <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-gradient-to-br from-cyan-500/20 to-violet-500/20 border border-white/10">
                  <item.icon size={19} className="text-cyan-300" />
                </div>
                <div>
                  <div className="font-mono-plex text-[10px] tracking-[0.25em] uppercase text-slate-500">
                    {item.label}
                  </div>
                  {item.href ? (
                    <a href={item.href} className="text-white font-medium hover:text-cyan-300 transition-colors">
                      {item.value}
                    </a>
                  ) : (
                    <div className="text-white font-medium">{item.value}</div>
                  )}
                </div>
              </div>
            ))}
            <div className="glass rounded-2xl p-6">
              <div className="eyebrow mb-3">What happens next</div>
              <ol className="space-y-3 text-sm text-slate-300">
                <li className="flex gap-3"><span className="font-mono-plex text-cyan-300">01</span> We confirm your slot by email.</li>
                <li className="flex gap-3"><span className="font-mono-plex text-cyan-300">02</span> 30-min call with a senior engineer.</li>
                <li className="flex gap-3"><span className="font-mono-plex text-cyan-300">03</span> You get a written gap map — free.</li>
              </ol>
            </div>
          </div>

          <div className="lg:col-span-8">
            <ContactForm />
          </div>
        </div>
      </section>
    </>
  );
}
